import { toast } from '@utils/functions/notificationToast'
import { useUser } from '.'

import type { AxiosError } from 'axios'
import type { PermissionsItemProps } from '@pages/AccessProfile/context/types'

import * as apiUser from '@services/api/user'

const getPagePermissions = (pageId: number): PermissionsItemProps | null => {
  const { userPermissionsData } = useUser.getState()

  if (!userPermissionsData || !userPermissionsData.permissions) return null

  const findPermissionById = (items: PermissionsItemProps[]): PermissionsItemProps | null => {
    const found = items.find((item) => item.id === pageId)
    if (found) return found

    return (
      items
        .map((item) => {
          if (item.children && item.children.length > 0) {
            return findPermissionById(item.children)
          }
          return null
        })
        .find((result) => result !== null) || null
    )
  }

  return findPermissionById(userPermissionsData.permissions)
}

const getUserPermissions = async (userId: number) => {
  const { setUserPermissionsData, setIsUserPermissionsLoading } = useUser.getState()

  setIsUserPermissionsLoading(true)

  try {
    const data = await apiUser.getUserPermissions(userId)

    setUserPermissionsData(data)
  } catch (error) {
    toast.error('Falha ao buscar as permissões do usuário!', (error as AxiosError)?.status)
  } finally {
    setIsUserPermissionsLoading(false)
  }
}

const getCompetenceDate = async (month: number) => {
  const { setIsCompetenceDateLoading, setCompetenceDateData } = useUser.getState()

  setIsCompetenceDateLoading(true)

  try {
    const data = await apiUser.getCompetenceDate(month)

    setCompetenceDateData(data)
  } catch (error) {
    const errorMessage =
      (error as AxiosError<{ errorMessage: string[] }>)?.response?.data?.errorMessage[0] ||
      'Falha ao obter as datas de competência!'

    toast.error(errorMessage, (error as AxiosError)?.status)
  } finally {
    setIsCompetenceDateLoading(false)
  }
}

export { getCompetenceDate, getUserPermissions, getPagePermissions }
